import request from '@/utils/request';

export function calculateCurtain(command) {
  return request({
    method: 'post',
    url: 'interior-decorator/calculate-curtain',
    data: command
  });
}

export function calculateRomanBlind(command) {
  return request({
    method: 'post',
    url: 'interior-decorator/calculate-roman-blind',
    data: command
  });
}

export function create(order) {
  return request({
    method: 'post',
    url: 'interior-decorator-order',
    data: order
  });
}

export function validate(order) {
  return request({
    method: 'post',
    url: 'interior-decorator-order/validate',
    data: order
  });
}

export function getProductGroupFinishes(productGroupID) {
  return request({
    method: 'get',
    url: `interior-decorator/product-group/${productGroupID}/finish`
  });
}

export function getGeneralFinishes() {
  return request({
    method: 'get',
    url: `interior-decorator/general-finish`
  });
}

export function getGrommets() {
  return request({
    method: 'get',
    url: `interior-decorator/grommets`
  });
}

export function getProductGroups() {
  return request({
    method: 'get',
    url: 'interior-decorator/product-group'
  });
}

export function getSettings() {
  return request({
    method: 'get',
    url: 'interior-decorator/settings'
  });
}

export function saveFabric(fabric) {
  return request({
    method: 'post',
    url: 'interior-decorator/fabric',
    data: fabric
  });
}

export const storeExtensions = {
  actions: {
    calculateCurtain({ dispatch }, command) {
      return new Promise((resolve, reject) =>
        calculateCurtain(command)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    calculateRomanBlind({ dispatch }, command) {
      return new Promise((resolve, reject) =>
        calculateRomanBlind(command)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    create({ dispatch }, order) {
      return new Promise((resolve, reject) =>
        create(order)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    validate({ dispatch }, order) {
      return new Promise((resolve, reject) =>
        validate(order)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    getProductGroupFinishes({ dispatch }, { productGroupID }) {
      return new Promise((resolve, reject) =>
        getProductGroupFinishes(productGroupID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    getGeneralFinishes({ dispatch }) {
      return new Promise((resolve, reject) =>
        getGeneralFinishes()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    getGrommets({ dispatch }) {
      return new Promise((resolve, reject) =>
        getGrommets()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    getProductGroups({ dispatch }) {
      return new Promise((resolve, reject) =>
        getProductGroups()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    getSettings({ dispatch }) {
      return new Promise((resolve, reject) =>
        getSettings()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    saveFabric({ dispatch }, fabric) {
      return new Promise((resolve, reject) =>
        saveFabric(fabric)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
